function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusEnvelope = function SvgPlusEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193 139"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 38 92.36 41.98a15.31 15.31 0 0 0 13.17-.24L191 38",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4,
      stroke: "#00db33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6 2h147.94C181.83 2 191 11.17 191 22.46v93.84c0 11.43-9.28 20.7-20.7 20.7H22.65C11.25 137 2 127.75 2 116.35V22.6C2 11.23 11.23 2 22.6 2Z",
    style: {
      stroke: "#007533",
      fill: "none",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  })));
};
export default SvgPlusEnvelope;